module.exports = "https://web-assets-production.autolist.com/_next/static/images/wagon-angled-1ebc54b6e37546a49d232b757476bdd1.jpg";